<div *ngIf="loading">
  <app-spinner></app-spinner>
</div>
<div *ngIf="!loading">
  <p class="mb-0100 pt-0025">Select what you would like to be included in your export:</p>


  <ng-container> <!-- Always visible because ids is always visible-->
    <h5 class="mt-0150 color--gray--005 caps txt-fw-500 txt-12">IDs</h5>
    <hr class="mt-0050">
    <div class="d-block mt-0050">
      <mat-checkbox class="mat-checkbox--responsive-wrap mat-checkbox--all-custom-ids"
                    [checked]="true"
                    [disabled]="true"
                    [disableRipple]="true">
        <span class="color--gray--006">IDs</span>
      </mat-checkbox>
      <div class="export__sub-option col__ col__sm--75">
        <mat-form-field class="col__ ongray mb-0050">
          <mat-label>Select IDs to export...</mat-label>
          <mat-select [(ngModel)]="selectedIds"
                      multiple>
            <mat-option *ngFor="let id of identifierOptions"
                        [disabled]="id.disabled"
                        [value]="id.value">
              {{id.label}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </ng-container>
  <div class="mb-0150">
    <ng-container *ngIf="canExportAnyProperty('name', 'nickname')">
      <h5 class="mt-0150 color--gray--005 caps txt-fw-500 txt-12">Name</h5>
      <hr class="mt-0050">
      <div class="d-block mt-0050"
           *ngIf="canExportProperty('name')">
        <mat-checkbox [checked]="selectedProperties.includes('name')"
                      (change)="propertiesCheckboxChanged('name');"
                      [disableRipple]="true">Name and Pronouns
        </mat-checkbox>
      </div>
      <div class="d-block"
           *ngIf="canExportProperty('nickname')">
        <mat-checkbox [checked]="selectedProperties.includes('nickname')"
                      (change)="propertiesCheckboxChanged('nickname');"
                      [disableRipple]="true">Preferred Name
        </mat-checkbox>
      </div>
    </ng-container>

    <ng-container *ngIf="canExportAnyProperty('date_of_birth', 'age')">
      <h5 class="mt-0150 color--gray--005 caps txt-fw-500 txt-12">Age &amp; Date of Birth</h5>
      <hr class="mt-0050">
      <div class="d-block mt-0050"
           *ngIf="canExportProperty('date_of_birth')">
        <mat-checkbox [checked]="selectedProperties.includes('date_of_birth')"
                      (change)="propertiesCheckboxChanged('date_of_birth');"
                      [disableRipple]="true">Birthday
        </mat-checkbox>
      </div>
      <div class="d-block"
           *ngIf="canExportProperty('age')">
        <mat-checkbox [checked]="selectedProperties.includes('age')"
                      (change)="propertiesCheckboxChanged('age');"
                      [disableRipple]="true">Age
        </mat-checkbox>
      </div>
    </ng-container>
    <ng-container *ngIf="canExportAnyProperty('languages', 'preferred_language')">
      <h5 class="mt-0150 color--gray--005 caps txt-fw-500 txt-12">
        Languages
      </h5>
      <hr class="mt-0050">
      <div class="d-block"
           *ngIf="canExportProperty('languages')">
        <mat-checkbox [checked]="selectedProperties.includes('languages')"
                      (change)="propertiesCheckboxChanged('languages');"
                      [disableRipple]="true">Spoken Languages
        </mat-checkbox>
      </div>
    </ng-container>

    <ng-container *ngIf="canExportAnyProperty('emails', 'home_addresses', 'phone_numbers')">
      <h5 class="mt-0150 color--gray--005 caps txt-fw-500 txt-12">Contact Info</h5>
      <hr class="mt-0050">
      <ng-container>
        <div class="d-block mt-0050"
             *ngIf="canExportProperty('home_addresses')">
          <mat-checkbox [checked]="selectedProperties.includes('home_addresses')"
                        (change)="propertiesCheckboxChanged('home_addresses');"
                        [disableRipple]="true">Address
          </mat-checkbox>
          <div class="export__sub-option row mb-0075"
               *ngIf="selectedProperties.includes('home_addresses')">
            <div class="row flexJustify-start flexAlign-center">
              <div class="ab-input-group col__ col__sm--55 mb-0050 mb-0--sm">
                <mat-form-field class="ongray ab-input-group__field">
                  <mat-label>Export Best...</mat-label>
                  <mat-select [(ngModel)]="propertyData.home_addresses.types">
                    <mat-option value="physical,mailing">Address (any type)</mat-option>
                    <mat-option value="physical">Address - Physical</mat-option>
                    <mat-option value="mailing">Address - Mailing</mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="ab-input-group__append">
                  <div class="ab-input-group__text">
                    <i class="fal fa-info-circle"
                       [matTooltip]="getExportBestTooltip('email')"></i>
                  </div>
                </div>
              </div>
              <div class="col__ col__sm--35 mb-0050 mb-0--sm ml-0100--sm">
                <mat-form-field class="ongray col__ mb-0">
                  <mat-label>How many?</mat-label>
                  <mat-select [(ngModel)]="propertyData.home_addresses.count">
                    <ng-container *ngFor="let num of [1,2,3]">
                      <mat-option [value]="num">{{num}} per entity</mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row flexJustify-start flexAlign-center"
                 *ngIf="selectedProperties.includes('home_addresses')">
              <mat-checkbox [(ngModel)]="propertyData.home_addresses.electoral_districts"
                            [disableRipple]="true"
                            class="mat-checkbox--responsive-wrap">Include Legislative Districts?
              </mat-checkbox>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="d-block"
           *ngIf="canExportProperty('emails')">
        <mat-checkbox class="mat-checkbox--responsive-wrap"
                      [checked]="selectedProperties.includes('emails')"
                      (change)="propertiesCheckboxChanged('emails');"
                      [disableRipple]="true">Email Address
        </mat-checkbox>
        <div class="export__sub-option row flexJustify-start"
             *ngIf="selectedProperties.includes('emails')">
          <div class="row flexJustify-start flexAlign-center">
            <div class="ab-input-group col__ col__sm--55 mb-0050 mb-0--sm">
              <mat-form-field class="ongray ab-input-group__field">
                <mat-label>Export Best...</mat-label>
                <mat-select [(ngModel)]="propertyData.emails.types">
                  <mat-option value="home,work">Email Address (any type)</mat-option>
                  <mat-option value="home">Email Address - Home</mat-option>
                  <mat-option value="work">Email Address - Work</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="ab-input-group__append">
                <div class="ab-input-group__text">
                  <i class="fal fa-info-circle"
                     [matTooltip]="getExportBestTooltip('email')"></i>
                </div>
              </div>
            </div>
            <div class="col__ col__sm--35 mb-0050 mb-0--sm ml-0100--sm">
              <mat-form-field class="col__ ongray mb-0">
                <mat-label>How many?</mat-label>
                <mat-select [(ngModel)]="propertyData.emails.count">
                  <ng-container *ngFor="let num of [1,2,3]">
                    <mat-option [value]="num">{{num}} per entity</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block"
           *ngIf="canExportProperty('phone_numbers')">
        <mat-checkbox class="mat-checkbox--responsive-wrap"
                      [checked]="selectedProperties.includes('phone_numbers')"
                      (change)="propertiesCheckboxChanged('phone_numbers');"
                      [disableRipple]="true">Phone Number
        </mat-checkbox>
        <div class="export__sub-option row flexJustify-start"
             *ngIf="selectedProperties.includes('phone_numbers')">
          <div class="row flexJustify-start flexAlign-center">
            <div class="ab-input-group col__ col__sm--55 mb-0050 mb-0--sm">
              <mat-form-field class="ab-input-group__field ongray">
                <mat-label>Export Best...</mat-label>
                <mat-select [(ngModel)]="propertyData.phone_numbers.types">
                  <mat-option value="home,work,cell">Phone Number (any type)</mat-option>
                  <mat-option value="cell">Phone Number - Mobile</mat-option>
                  <mat-option value="home">Phone Number - Home</mat-option>
                  <mat-option value="work">Phone Number - Work</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="ab-input-group__append">
                <div class="ab-input-group__text">
                  <i class="fal fa-info-circle"
                     [matTooltip]="getExportBestTooltip('phone')"></i>
                </div>
              </div>
            </div>
            <div class="col__ col__sm--35 mb-0050 mb-0--sm ml-0100--sm">
              <mat-form-field class="col__ ongray mb-0">
                <mat-label>How many?</mat-label>
                <mat-select [(ngModel)]="propertyData.phone_numbers.count">
                  <ng-container *ngFor="let num of [1,2,3]">
                    <mat-option [value]="num">{{num}} per entity</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="canExportAnyProperty('most_recent_assessment', 'social_profile')">
      <!-- Always visible because ids is always visible-->
      <h5 class="mt-0150 color--gray--005 caps txt-fw-500 txt-12">Other Profile Data</h5>
      <hr class="mt-0050">
      <div class="d-block mt-0050"
           *ngIf="canExportProperty('social_profile')">
        <mat-checkbox [checked]="selectedProperties.includes('social_profile')"
                      (change)="propertiesCheckboxChanged('social_profile');"
                      [disableRipple]="true">Social Media Profile
        </mat-checkbox>
      </div>
      <div class="d-block"
           *ngIf="canExportProperty('most_recent_assessment')">
        <mat-checkbox [checked]="selectedProperties.includes('most_recent_assessment')"
                      (change)="propertiesCheckboxChanged('most_recent_assessment');"
                      [disableRipple]="true">Most Recent Assessment
        </mat-checkbox>
      </div>
    </ng-container>

    <ng-container *ngIf="canExportAnyProperty('most_recent_connection', 'most_recent_notes')">
      <h5 class="mt-0150 color--gray--005 caps txt-fw-500 txt-12">Notes &amp; Connections</h5>
      <hr class="mt-0050">
      <div class="d-block mt-0050"
           *ngIf="canExportProperty('most_recent_connection')">
        <mat-checkbox [checked]="selectedProperties.includes('most_recent_connection')"
                      (change)="propertiesCheckboxChanged('most_recent_connection');"
                      [disableRipple]="true">Most Recent Connection
        </mat-checkbox>
        <div class="export__sub-option col__ col__sm--55"
             *ngIf="selectedProperties.includes('most_recent_connection')">
          <mat-form-field class="col__ ongray mb-0050"
                          *ngIf="selectedProperties.includes('most_recent_connection')">
            <mat-label>Select Connection Type</mat-label>
            <mat-select placeholder="Connection Type"
                        name="role"
                        [required]="true"
                        [(ngModel)]="propertyData.most_recent_connection.entity_connection_type_id">
              <mat-select-trigger>
                <app-connection-type-name
                                          [connectionType]="getConnectionTypeById(propertyData.most_recent_connection.entity_connection_type_id)">
                </app-connection-type-name>
              </mat-select-trigger>
              <mat-option *ngFor="let ect of connectionTypeOptions"
                          [value]="ect.id">
                <app-connection-type-name [connectionType]="ect">
                </app-connection-type-name>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="d-block"
           *ngIf="canExportProperty('most_recent_notes')">
        <mat-checkbox class="mat-checkbox--responsive-wrap"
                      [checked]="selectedProperties.includes('most_recent_notes')"
                      (change)="propertiesCheckboxChanged('most_recent_notes');"
                      [disableRipple]="true">Most Recent Note(s)
        </mat-checkbox>
        <div class="export__sub-option col__ col__sm--55"
             *ngIf="selectedProperties.includes('most_recent_notes')">
          <mat-form-field class="col__ ongray mb-0050">
            <mat-label>How many?</mat-label>
            <mat-select [(ngModel)]="propertyData.most_recent_notes.count">
              <mat-option [value]="1">Last 1 note</mat-option>
              <mat-option [value]="2">Last 2 notes</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="mb-0150"
       *ngIf="canExportProperty('tags')">
    <div class="mb-0075">
      <h5 class="mt-0150 color--gray--005 caps txt-fw-500 txt-12 flex flexJustify-between">
        <span>
          Fields
          <span class="txt-fw-400 color--gray">({{propertyData.tags.tag_category_ids?.length || 0}} selected)</span>
        </span>
        <button class="link link--no-line p-0 caps txt-12 txt-fw-500"
                type="button"
                *ngIf="propertyData.tags.tag_category_ids.length > 0"
                (click)="selectedCategoriesChanged([])"
                aria-details="Clear all selected fields">
          Reset
        </button>
      </h5>
      <hr class="mt-0050">
      <app-field-search-inline [campaignId]="campaignId"
                               [targetType]="'EntityType'"
                               [withTypeSelect]="true"
                               [multiple]="true"
                               [filterOptionsFn]="buildCategoryFilterFunction()"
                               [selectedOptions]="selectedCategories"
                               (selectedOptionsChange)="selectedCategoriesChanged($event)"
                               class="scrollable-quicksearch--wrapper d-block"></app-field-search-inline>
    </div>

  </div>

  <button type="button"
          class="btn"
          [disabled]="isInvalid()"
          (click)="onRunStandardExportClick()">
    Export {{recordCount}}
    {{recordCount === 1 ? 'Record' : 'Records'}}
  </button>
</div>
